// extracted by mini-css-extract-plugin
export default {"triangle":"styles_triangle__0OCnj"};